import React from 'react';
import { Form, Field } from 'react-final-form';
import { FormattedMessage } from 'react-intl';

import { checkEmail } from '../../helpers';
import { renderPlaceholderTextField } from './fields';
import { connect } from 'react-redux';
import { getMessage as t } from '../../utils/utils';
import { messagesSelector } from '../../helpers/selectors';

const validate = (values, props) => {
  const errors = {};

  const emailError = checkEmail(values.login, props.m);

  if (emailError) errors.login = emailError;

  return errors;
};

const ForgotPasswordForm = (props) => {
  const { onSubmit, forgotPasswordError, forgotPasswordFetching, m } = props;

  return (
    <div>
      <div className="forgot-pass-desc">
        <FormattedMessage id="forgot_password.description_line1" />
        <br />
        <FormattedMessage id="forgot_password.description_line2" />
      </div>
      <Form onSubmit={onSubmit} validate={(values) => validate(values, props)}>
        {({ handleSubmit }) => (
          <form
            className="form-content forgot-password-form"
            onSubmit={handleSubmit}
            noValidate
          >
            <Field
              name="login"
              component={renderPlaceholderTextField}
              placeholder={t(m, 'generic.email')}
              type="email"
            />
            {forgotPasswordError && (
              <div className="text-danger text-center mt-5">{forgotPasswordError}</div>
            )}
            <div className="text-center">
              <button
                disabled={!!forgotPasswordFetching}
                className="btn btn-accent primary-btn btn-md mt-10"
              >
                <FormattedMessage id="forgot_password.submit" />
              </button>
            </div>
          </form>
        )}
      </Form>
    </div>
  );
};

const mapStateToProps = (state) => {
  return { m: messagesSelector(state) };
};


export default connect(mapStateToProps)(ForgotPasswordForm);
